export default __webpack_public_path__ + "static/media/wedding3.c91842fe.webp";